export const tagsApiBaseUrl = process.env.REACT_APP_API_BASE_URL!;
